export const defaultRegionCode = 'USA';
export const defaultLang = 'en-US';

export const warnOnMarketChangeTo = ['TWN', 'KOR'];
